<vex-page-layout mode="card">

    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.container]="layoutCtrl.value === 'boxed'"
             [class.px-gutter]="layoutCtrl.value === 'fullwidth'"
             class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">{{ "MENUS.PROYECTOS_JERARQUICOS" | translate }}</h1>
                <vex-breadcrumbs
                    [crumbs]="['MENUS.ADMINISTRACION', 'MENUS.PROYECTOS_JERARQUICOS']"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">

        <div>
            <form [formGroup]="searchForm">
                <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">

                    <div class="bg-foreground rounded-full px-4 h-10 max-w-[400px] flex-auto flex items-center border border-gray-300">
                        <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                        <input formControlName="search"
                               class="px-4 py-2 border-0 outline-none w-full bg-transparent"
                               [placeholder]="'ACTIONS.BUSCAR_PROYECTOS' | translate"
                               type="search"
                               (keyup.enter)="buscar()">
                    </div>

                    <!-- Filtro por tipo de proyecto con el mismo estilo que buscar -->
                    <div class="bg-foreground rounded-full px-4 h-10 max-w-[200px] flex items-center border border-gray-300 ml-4">
                        <mat-icon class="icon-sm text-secondary" svgIcon="mat:category"></mat-icon>
                        <select formControlName="tipo" 
                                (change)="buscar()"
                                class="px-4 py-2 border-0 outline-none w-full bg-transparent appearance-none cursor-pointer">
                            <option *ngFor="let tipo of projectTypes" [value]="tipo.id">
                                {{ tipo.name }}
                            </option>
                        </select>
                    </div>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.BUSCAR' | translate"
                        type="button"
                        (click)="buscar()">
                        <mat-icon svgIcon="mat:search"></mat-icon>
                    </button>

                    <span class="flex-1"></span>

                    <button
                        class="ml-4 flex-none"
                        color="warn"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.RECHAZAR_FORZAR_COMENTARIOS' | translate"
                        type="button"
                        (click)="rechazarSelected()"
                        [disabled]="selection.selected.length === 0">
                        <mat-icon svgIcon="mat:clear"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.FORZAR_COMENTARIOS' | translate"
                        type="button"
                        (click)="aprobarSelected()"
                        [disabled]="selection.selected.length === 0">
                        <mat-icon svgIcon="mat:check"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="accent"
                        mat-mini-fab
                        matTooltip="Expandir un nivel"
                        type="button"
                        (click)="expandOneLevel()">
                        <mat-icon svgIcon="mat:expand_more"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="warn"
                        mat-mini-fab
                        matTooltip="Contraer un nivel"
                        type="button"
                        (click)="collapseOneLevel()">
                        <mat-icon svgIcon="mat:expand_less"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.AGREGAR_PROYECTO_RAIZ' | translate"
                        (click)="createRootNode()"
                        type="button">
                        <mat-icon svgIcon="mat:add"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.EXPORTAR' | translate"
                        type="button"
                        (click)="export()"
                        [disabled]="isLoading">
                        <mat-icon svgIcon="mat:cloud_download"></mat-icon>
                    </button>

                </div>
            </form>

            <table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
                
                <!-- Columna de Nombre con indentación y controles de expansión -->
                <ng-container matColumnDef="name">
                    <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                        {{ "GRIDS.NOMBRE" | translate }}
                    </th>
                    <td *matCellDef="let row" [ngClass]="columns[1].cssClasses" mat-cell>
                        <div class="flex items-center" [style.padding-left]="getIndentation(row)">
                            <!-- Botón de expansión/contracción -->
                            <button 
                                *ngIf="hasChildren(row)" 
                                mat-icon-button 
                                class="w-6 h-6 mr-2"
                                (click)="toggleNode(row); $event.stopPropagation()">
                                <mat-icon class="text-secondary" [svgIcon]="row.expanded ? 'mat:expand_less' : 'mat:expand_more'"></mat-icon>
                            </button>
                            
                            <!-- Espaciador para nodos sin hijos -->
                            <span *ngIf="!hasChildren(row)" class="w-6 h-6 mr-2"></span>
                            
                            <!-- Icono del nodo -->
                            <mat-icon class="text-primary mr-2" 
                                     [svgIcon]="row.level === 0 ? 'mat:folder' : (row.hasChildren ? 'mat:folder_open' : 'mat:description')">
                            </mat-icon>
                            
                            <!-- Nombre del nodo -->
                            <span>{{ row.name }}</span>
                        </div>
                    </td>
                </ng-container>

                <!-- Columna de Código -->
                <ng-container matColumnDef="code">
                    <th *matHeaderCellDef class="uppercase text-center" mat-header-cell mat-sort-header>
                        {{ "GRIDS.CODIGO" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell class="text-center">
                        {{ row.code }}
                    </td>
                </ng-container>

                <!-- Columna de Activo -->
                <ng-container matColumnDef="active">
                    <th *matHeaderCellDef class="uppercase text-center" mat-header-cell mat-sort-header>
                        {{ "GRIDS.ACTIVO" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell class="text-center">
                        <mat-icon *ngIf="row.active" svgIcon="mat:check" class="text-green-600"></mat-icon>
                        <mat-icon *ngIf="!row.active" svgIcon="mat:clear" class="text-red-600"></mat-icon>
                    </td>
                </ng-container>

                <!-- Columna de Visible -->
                <ng-container matColumnDef="visible">
                    <th *matHeaderCellDef class="uppercase text-center" mat-header-cell mat-sort-header>
                        Visible
                    </th>
                    <td *matCellDef="let row" mat-cell class="text-center">
                        <mat-icon *ngIf="row.visible !== false" svgIcon="mat:visibility" class="text-green-600"></mat-icon>
                        <mat-icon *ngIf="row.visible === false" svgIcon="mat:visibility_off" class="text-red-600"></mat-icon>
                    </td>
                </ng-container>

                <!-- Columna de Requiere Observación -->
                <ng-container matColumnDef="requiereObservacion">
                    <th *matHeaderCellDef class="uppercase text-center" mat-header-cell mat-sort-header>
                        {{ "GRIDS.FORZAR" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell class="text-center">
                        <mat-icon *ngIf="row.requiereObservacion" svgIcon="mat:check" class="text-green-600"></mat-icon>
                        <mat-icon *ngIf="!row.requiereObservacion" svgIcon="mat:clear" class="text-red-600"></mat-icon>
                    </td>
                </ng-container>

                <!-- Resto de columnas de texto -->
                <ng-container *ngFor="let column of columns; trackBy: trackByProperty">
                    <ng-container *ngIf="column.type === 'text' && column.property !== 'name' && column.property !== 'code' && column.visible" 
                                  [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            {{ column.label | translate }}
                        </th>
                        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
                            {{ row[column.property] }}
                        </td>
                    </ng-container>
                </ng-container>

                <!-- Columna de selección para Requiere Observación -->
                <ng-container matColumnDef="selectedReqObs">
                    <th *matHeaderCellDef class="uppercase" mat-header-cell>
                        <mat-checkbox 
                            (change)="$event ? masterToggleReqObs() : null"
                            [checked]="isAllReqObsSelected()"
                            [indeterminate]="isSomeReqObsSelected() && !isAllReqObsSelected()"
                            color="primary">
                            SEL. TODOS REQ. OBS.
                        </mat-checkbox>
                    </th>
                    <td *matCellDef="let row" mat-cell>
                        <mat-checkbox 
                            (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"
                            [disabled]="!row.requiereObservacion"
                            color="primary">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <!-- Columna de acciones -->
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell>{{ "GRIDS.ACCIONES" | translate }}</th>
                    <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
                        <button (click)="$event.stopPropagation()"
                                [matMenuTriggerData]="{ node: row }"
                                [matMenuTriggerFor]="actionsMenu"
                                mat-icon-button
                                type="button">
                            <mat-icon svgIcon="mat:more_horiz"></mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr (click)="updateNode(row)"
                    *matRowDef="let row; columns: visibleColumns;"
                    @fadeInUp
                    class="hover:bg-hover trans-ease-out cursor-pointer"
                    mat-row></tr>

            </table>

            <!-- Paginador -->
            <mat-paginator 
                [length]="totalRecords"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                [pageIndex]="currentPage"
                (page)="pageChanged($event)"
                showFirstLastButtons>
            </mat-paginator>

            <!-- Mensaje cuando no hay datos -->
            <div *ngIf="!isLoading && flatNodeList.length === 0" 
                 class="flex flex-col items-center justify-center py-16">
                <mat-icon class="text-6xl text-secondary mb-4" svgIcon="mat:folder_open"></mat-icon>
                <h3 class="text-xl font-medium text-secondary mb-2">
                    {{ "MESSAGES.NO_PROJECTS" | translate }}
                </h3>
                <p class="text-secondary mb-4">
                    {{ "MESSAGES.CREATE_FIRST_PROJECT" | translate }}
                </p>
                <button mat-raised-button color="primary" (click)="createRootNode()">
                    <mat-icon svgIcon="mat:add"></mat-icon>
                    {{ "ACTIONS.CREAR_PROYECTO_RAIZ" | translate }}
                </button>
            </div>

            <!-- Loading spinner -->
            <div *ngIf="isLoading" class="flex justify-center py-16">
                <mat-spinner></mat-spinner>
            </div>

        </div>

    </vex-page-layout-content>

</vex-page-layout>

<!-- Menú contextual -->
<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
    <ng-template let-node="node" matMenuContent>
        <button (click)="updateNode(node)" mat-menu-item>
            <mat-icon svgIcon="mat:edit"></mat-icon>
            <span>{{ "ACTIONS.EDITAR" | translate }}</span>
        </button>
        <button (click)="createChildNode(node)" mat-menu-item>
            <mat-icon svgIcon="mat:add_circle"></mat-icon>
            <span>{{ "ACTIONS.AGREGAR_HIJO" | translate }}</span>
        </button>
        <mat-divider></mat-divider>
        <button (click)="deleteNode(node)" mat-menu-item class="text-warn">
            <mat-icon svgIcon="mat:delete"></mat-icon>
            <span>{{ "ACTIONS.ELIMINAR" | translate }}</span>
        </button>
    </ng-template>
</mat-menu>
